import { formatToDevanagariStyle } from "@/utilities/helper"

export const columns = [
  { accessorKey: "sale_year", header: "Sale Year" },
  {
    accessorKey: "total_sales",
    header: "Total Sales",
    cell: ({ row }) =>
      `Rs. ${formatToDevanagariStyle(row.original.total_sales)}`,
  },
  { accessorKey: "total_orders", header: "Total Orders" },
]
